<section class="content">
  <div class="card">
    <div class="card-body-placeholder">
      <img src="../../../assets/images/icons/confetti.png" width="64"/>
      <h2 class="mt-5">Payment successful!</h2>
      <p class="mb-5">Thank you for your payment. You'll be automatically redirected to the report list in few seconds</p>
    </div>
  </div>
  <app-special-offer-popup></app-special-offer-popup>
</section>




